const wxpvConfig = {
  primitive: {
    borderRadius: {
      none: '0',
      xs: '2px',
      sm: '4px',
      md: '6px',
      lg: '8px',
      xl: '12px',
    },
    spacing: {
      xxs: '0.285714285rem',
      xs: '0.57142857rem',
      sm: '0.857142857rem',
      md: '1.142857rem',
      lg: '1.7142857rem',
      xl: '2.2857rem',
    },
    inputHeight: '43px',
    emerald: {
      50: '#E8F6F1',
      100: '#C5EBE1',
      200: '#9EDFCF',
      300: '#76D3BD',
      400: '#58C9AF',
      500: '#3BBFA1',
      600: '#35AF94',
      700: '#2D9B83',
      800: '#268873',
      900: '#1A6657',
      950: '#0d3329',
    },
    green: {
      50: '#f6fbf5',
      100: '#d5ecce',
      200: '#ebf8e7',
      300: '#94cd80',
      400: '#73bd59',
      500: '#52ae32',
      600: '#46942b',
      700: '#397a23',
      800: '#2d601c',
      900: '#214614',
      950: '#152c0d',
    },
    lime: {
      50: '#F9FBE7',
      100: '#F0F4C3',
      200: '#E6EE9C',
      300: '#DCE775',
      400: '#D4E157',
      500: '#CDDC39',
      600: '#C0CA33',
      700: '#AFB42B',
      800: '#9E9D24',
      900: '#827717',
      950: '#413c0c',
    },
    red: {
      50: '#fbf2f4',
      100: '#ecc2c9',
      200: '#dd919f',
      300: '#ce6175',
      400: '#bf304a',
      500: '#ff0000',
      600: '#b00020',
      700: '#96001b',
      800: '#7b0016',
      900: '#610012',
      950: '#46000d',
    },
    orange: {
      50: '#fffbf2',
      100: '#ffebc2',
      200: '#ffdb91',
      300: '#ffcb61',
      400: '#ffbb30',
      500: '#ffab00',
      600: '#d99100',
      700: '#b37800',
      800: '#8c5e00',
      900: '#664400',
      950: '#402b00',
    },
    amber: {
      50: '#fffcf2',
      100: '#fff1c2',
      200: '#ffe691',
      300: '#ffda61',
      400: '#ffcf30',
      500: '#ffc400',
      600: '#d9a700',
      700: '#b38900',
      800: '#8c6c00',
      900: '#664e00',
      950: '#403100',
    },
    yellow: {
      50: '#FFFDE7',
      100: '#FFF9C4',
      200: '#FFF59D',
      300: '#FFF176',
      400: '#FFEE58',
      500: '#FFEB3B',
      600: '#FDD835',
      700: '#FBC02D',
      800: '#F9A825',
      900: '#F57F17',
      950: '#7b400c',
    },
    teal: {
      50: '#E0F2F1',
      100: '#B2DFDB',
      200: '#80CBC4',
      300: '#4DB6AC',
      400: '#26A69A',
      500: '#009688',
      600: '#00897B',
      700: '#00796B',
      800: '#00695C',
      900: '#004D40',
      950: '#002720',
    },
    cyan: {
      50: '#E0F7FA',
      100: '#B2EBF2',
      200: '#80DEEA',
      300: '#4DD0E1',
      400: '#26C6DA',
      500: '#00BCD4',
      600: '#00ACC1',
      700: '#0097A7',
      800: '#00838F',
      900: '#006064',
      950: '#003032',
    },
    sky: {
      50: '#E1F5FE',
      100: '#B3E5FC',
      200: '#81D4FA',
      300: '#4FC3F7',
      400: '#29B6F6',
      500: '#03A9F4',
      600: '#039BE5',
      700: '#0288D1',
      800: '#0277BD',
      900: '#01579B',
      950: '#012c4e',
    },
    blue: {
      50: '#E3F2FD',
      100: '#BBDEFB',
      200: '#90CAF9',
      300: '#64B5F6',
      400: '#42A5F5',
      500: '#2196F3',
      600: '#1E88E5',
      700: '#1976D2',
      800: '#1565C0',
      900: '#0D47A1',
      950: '#072451',
    },
    indigo: {
      50: '#E8EAF6',
      100: '#C5CAE9',
      200: '#9FA8DA',
      300: '#7986CB',
      400: '#5C6BC0',
      500: '#3F51B5',
      600: '#3949AB',
      700: '#303F9F',
      800: '#283593',
      900: '#1A237E',
      950: '#0d123f',
    },
    violet: {
      50: '#EDE7F6',
      100: '#D1C4E9',
      200: '#B39DDB',
      300: '#9575CD',
      400: '#7E57C2',
      500: '#673AB7',
      600: '#5E35B1',
      700: '#512DA8',
      800: '#4527A0',
      900: '#311B92',
      950: '#190e49',
    },
    purple: {
      50: '#F3E5F5',
      100: '#E1BEE7',
      200: '#CE93D8',
      300: '#BA68C8',
      400: '#AB47BC',
      500: '#9C27B0',
      600: '#8E24AA',
      700: '#7B1FA2',
      800: '#6A1B9A',
      900: '#4A148C',
      950: '#250a46',
    },
    fuchsia: {
      50: '#FDE6F3',
      100: '#FBC1E3',
      200: '#F897D1',
      300: '#F56DBF',
      400: '#F34DB2',
      500: '#F12DA5',
      600: '#E0289D',
      700: '#CC2392',
      800: '#B81E88',
      900: '#951777',
      950: '#4b0c3c',
    },
    pink: {
      50: '#FCE4EC',
      100: '#F8BBD0',
      200: '#F48FB1',
      300: '#F06292',
      400: '#EC407A',
      500: '#E91E63',
      600: '#D81B60',
      700: '#C2185B',
      800: '#AD1457',
      900: '#880E4F',
      950: '#440728',
    },
    rose: {
      50: '#FFF0F0',
      100: '#FFD9D9',
      200: '#FFC0C0',
      300: '#FFA7A7',
      400: '#FF8E8E',
      500: '#FF7575',
      600: '#FF5252',
      700: '#FF3838',
      800: '#F71C1C',
      900: '#D50000',
      950: '#3E0000',
    },
    slate: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    gray: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
      950: '#030712',
    },
    zinc: {
      50: '#fafafa',
      100: '#f4f4f5',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b',
      950: '#09090b',
    },
    neutral: {
      50: '#f8f8f8',
      100: '#dedede',
      200: '#c4c4c4',
      300: '#aaaaaa',
      400: '#909090',
      500: '#767676',
      600: '#646464',
      700: '#535353',
      800: '#414141',
      900: '#2f2f2f',
      950: '#1e1e1e',
    },
    stone: {
      50: '#fafaf9',
      100: '#f5f5f4',
      200: '#e7e5e4',
      300: '#d6d3d1',
      400: '#a8a29e',
      500: '#78716c',
      600: '#57534e',
      700: '#44403c',
      800: '#292524',
      900: '#1c1917',
      950: '#0c0a09',
    },
  },
  semantic: {
    transitionDuration: '0.2s',
    focusRing: {
      width: '0',
      style: 'none',
      color: 'unset',
      offset: '0',
    },
    disabledOpacity: '0.38',
    iconSize: '1rem',
    anchorGutter: '0',
    primary: {
      50: '#eaf5e6',
      100: '#d5ecce',
      200: '#c7e5bd',
      300: '#94cd80',
      400: '#73bd59',
      500: '#52ae32',
      600: '#46942b',
      700: '#397a23',
      800: '#2d601c',
      900: '#214614',
      950: '#152c0d',
    },
    formField: {
      paddingX: '{spacing.sm}',
      paddingY: '{spacing.sm}',
      fontSize: '1rem',
      sm: {
        paddingX: '{spacing.xs}',
        paddingY: '{spacing.xs}',
      },
      lg: {
        fontSize: '1.125rem',
        paddingX: '0.825rem',
        paddingY: '0.825rem',
      },
      borderRadius: '{border.radius.sm}',
      focusRing: {
        width: '2px',
        style: 'solid',
        color: '{primary.color}',
        offset: '-2px',
        shadow: 'none',
      },
      transitionDuration: '{transition.duration}',
    },
    list: {
      padding: '0.5rem 0',
      gap: '0',
      header: {
        padding: '0.75rem 1rem',
      },
      option: {
        padding: '0.75rem 1rem',
        borderRadius: '{border.radius.none}',
      },
      optionGroup: {
        padding: '0.75rem 1rem',
        fontWeight: '700',
      },
    },
    content: {
      borderRadius: '{border.radius.sm}',
    },
    mask: {
      transitionDuration: '0.15s',
    },
    navigation: {
      list: {
        padding: '0.5rem 0',
        gap: '0',
      },
      item: {
        padding: '0.75rem 1rem',
        borderRadius: '{border.radius.none}',
        gap: '0.5rem',
      },
      submenuLabel: {
        padding: '0.75rem 1rem',
        fontWeight: '700',
      },
      submenuIcon: {
        size: '0.875rem',
      },
    },
    overlay: {
      select: {
        borderRadius: '{border.radius.sm}',
        shadow:
          '0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)',
      },
      popover: {
        borderRadius: '{border.radius.sm}',
        padding: '1rem',
        shadow:
          '0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12)',
      },
      modal: {
        borderRadius: '{border.radius.sm}',
        padding: '1.5rem',
        shadow:
          '0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12)',
      },
      navigation: {
        shadow:
          '0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12)',
      },
    },
    colorScheme: {
      light: {
        focusRing: {
          shadow: '0 0 1px 4px {surface.200}',
        },
        surface: {
          0: '#ffffff', // Cards Background
          50: '#f9f9f9', // App background
          100: '#dedede',
          200: '#d2d2d2', // inactive states and borders (tab-navigation table-row, headlines)
          300: '#a6a6a6', // disabled text
          400: '#a2a2a2', // table header border
          500: '#767676', // secondary text
          600: '#7c7c7c', // field labels & field icons
          700: '#5b5b5b', // lines & graphics
          800: '#333333', // default titles, headers, icons
          900: '#2f2f2f', // default text
          950: '#1e1e1e',
        },
        primary: {
          color: '{primary.500}',
          contrastColor: '{surface.0}',
          hoverColor: '{primary.400}',
          activeColor: '{primary.300}',
        },
        statusColor: {
          info: '{blue.500}',
          success: '{green.500}',
          warn: '{amber.500}',
          error: '{red.500}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}',
        },
        mask: {
          background: 'rgba(0,0,0,0.32)',
          color: '{surface.200}',
        },
        formField: {
          background: '{surface.0}',
          disabledBackground: '{surface.0}',
          filledBackground: '{surface.100}',
          filledHoverBackground: '{surface.200}',
          filledFocusBackground: '{surface.100}',
          borderColor: '{surface.400}',
          hoverBorderColor: '{surface.900}',
          focusBorderColor: '{primary.color}',
          invalidBorderColor: '{red.500}',
          color: '{surface.900}',
          disabledColor: '{surface.300}',
          placeholderColor: '{surface.600}',
          invalidPlaceholderColor: '{red.500}',
          floatLabelColor: '{surface.600}',
          floatLabelFocusColor: '{primary.600}',
          floatLabelActiveColor: '{surface.600}',
          floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
          iconColor: '{surface.600}',
          shadow: 'none',
        },
        text: {
          color: '{surface.900}',
          hoverColor: '{surface.900}',
          mutedColor: '{surface.600}',
          hoverMutedColor: '{surface.600}',
        },
        content: {
          background: '{surface.0}',
          hoverBackground: '{surface.50}',
          borderColor: '{surface.400}',
          color: '{text.color}',
          hoverColor: '{text.hover.color}',
        },
        overlay: {
          select: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{text.color}',
          },
          popover: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{text.color}',
          },
          modal: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{text.color}',
          },
        },
        list: {
          option: {
            focusBackground: '{surface.100}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
            icon: {
              color: '{surface.600}',
              focusColor: '{surface.600}',
            },
          },
          optionGroup: {
            background: 'transparent',
            color: '{text.color}',
          },
        },
        navigation: {
          item: {
            focusColor: '{primary.color}',
            focusBackground: 'transparent',
            activeBackground: '{surface.200}',
            color: '{text.color}',
            activeColor: '{text.hover.color}',
            icon: {
              color: '{surface.600}',
              focusColor: '{surface.600}',
              activeColor: '{surface.600}',
            },
          },
          submenuLabel: {
            background: 'transparent',
            color: '{text.color}',
          },
          submenuIcon: {
            color: '{surface.600}',
            focusColor: '{surface.600}',
            activeColor: '{surface.600}',
          },
        },
      },
      dark: {
        focusRing: {
          shadow: '0 0 1px 4px {surface.200}',
        },
        surface: {
          0: '#ffffff', // Cards Background
          50: '#f9f9f9', // App background
          100: '#dedede',
          200: '#d2d2d2', // inactive states and borders (tab-navigation table-row, headlines)
          300: '#a6a6a6', // disabled text
          400: '#a2a2a2', // table header border
          500: '#767676', // secondary text
          600: '#7c7c7c', // field labels & field icons
          700: '#5b5b5b', // lines & graphics
          800: '#333333', // default titles, headers, icons
          900: '#2f2f2f', // default text
          950: '#1e1e1e',
        },
        primary: {
          color: '{primary.500}',
          contrastColor: '{surface.0}',
          hoverColor: '{primary.400}',
          activeColor: '{primary.300}',
        },
        statusColor: {
          info: '{blue.500}',
          success: '{green.500}',
          warn: '{amber.500}',
          error: '{red.500}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}',
        },
        mask: {
          background: 'rgba(0,0,0,0.32)',
          color: '{surface.200}',
        },
        formField: {
          background: '{surface.0}',
          disabledBackground: '{surface.0}',
          filledBackground: '{surface.100}',
          filledHoverBackground: '{surface.200}',
          filledFocusBackground: '{surface.100}',
          borderColor: '{surface.400}',
          hoverBorderColor: '{surface.900}',
          focusBorderColor: '{primary.color}',
          invalidBorderColor: '{red.500}',
          color: '{surface.900}',
          disabledColor: '{surface.300}',
          placeholderColor: '{surface.600}',
          invalidPlaceholderColor: '{red.500}',
          floatLabelColor: '{surface.600}',
          floatLabelFocusColor: '{primary.600}',
          floatLabelActiveColor: '{surface.600}',
          floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
          iconColor: '{surface.600}',
          shadow: 'none',
        },
        text: {
          color: '{surface.900}',
          hoverColor: '{surface.900}',
          mutedColor: '{surface.600}',
          hoverMutedColor: '{surface.600}',
        },
        content: {
          background: '{surface.0}',
          hoverBackground: '{surface.50}',
          borderColor: '{surface.400}',
          color: '{text.color}',
          hoverColor: '{text.hover.color}',
        },
        overlay: {
          select: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{text.color}',
          },
          popover: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{text.color}',
            padding: '{spacing.md}',
          },
          modal: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{text.color}',
          },
        },
        list: {
          option: {
            focusBackground: '{surface.100}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
            icon: {
              color: '{surface.600}',
              focusColor: '{surface.600}',
            },
          },
          optionGroup: {
            background: 'transparent',
            color: '{text.color}',
          },
        },
        navigation: {
          item: {
            focusColor: '{primary.color}',
            focusBackground: 'transparent',
            activeBackground: '{surface.200}',
            color: '{text.color}',
            activeColor: '{text.hover.color}',
            icon: {
              color: '{surface.600}',
              focusColor: '{surface.600}',
              activeColor: '{surface.600}',
            },
          },
          submenuLabel: {
            background: 'transparent',
            color: '{text.color}',
          },
          submenuIcon: {
            color: '{surface.600}',
            focusColor: '{surface.600}',
            activeColor: '{surface.600}',
          },
        },
      },
    },
  },
  components: {
    badge: {
      colorScheme: {
        light: {
          secondary: {
            background: '{primary.color}',
            color: '{surface.0}',
          },
        },
        dark: {
          secondary: {
            background: '{primary.color}',
            color: '{surface.0}',
          },
        },
      },
    },
    button: {
      iconOnlyWidth: '1.5rem',
      colorScheme: {
        light: {
          text: {
            secondaryColor: '{formField.color}',
            secondaryHoverColor: '{primary.color}',
            secondaryHoverBackground: '{formField.background}',
            secondaryActiveBackground: '{formField.background}',
          },
          secondary: {
            background: '{formField.background}',
            color: '{formField.color}',
            hoverColor: '{primary.color}',
            hoverBorderColor: '{primary.color}',
            borderColor: '{formField.color}',
            hoverBackground: '{formField.background}',
            activeBackground: '{formField.background}',
            activeColor: '{primary.color}',
          },
          danger: {
            color: '{surface.0}',
            borderColor: '{red.400}',
            background: '{red.400}',
            hoverColor: '{surface.0}',
            hoverBackground: '{red.400}',
            hoverBorderColor: '{red.400}',
          },
        },
        dark: {
          text: {
            secondaryColor: '{formField.color}',
            secondaryHoverColor: '{primary.color}',
            secondaryHoverBackground: '{formField.background}',
            secondaryActiveBackground: '{formField.background}',
          },
          secondary: {
            background: '{formField.background}',
            color: '{formField.color}',
            hoverColor: '{primary.color}',
            hoverBorderColor: '{primary.color}',
            borderColor: '{formField.color}',
            hoverBackground: '{formField.background}',
            activeBackground: '{formField.background}',
            activeColor: '{primary.color}',
          },
          danger: {
            color: '{surface.0}',
            borderColor: '{red.400}',
            background: '{red.400}',
            hoverColor: '{surface.0}',
            hoverBackground: '{red.400}',
            hoverBorderColor: '{red.400}',
          },
        },
      },
    },
    card: {
      body: {
        padding: '24px',
      },
      shadow: '1px 2px 4px #00000029',
    },
    checkbox: {
      width: '20px',
      height: '20px',
      borderRadius: '{border.radius.sm}',
      colorScheme: {
        light: {
          hoverBorderColor: '{primary.color}',
        },
        dark: {
          hoverBorderColor: '{primary.color}',
        },
      },
      label: {
        colorScheme: {
          light: {
            color: '{text.color}',
          },
          dark: {
            color: '{text.color}',
          },
        },
      },
    },
    chip: {
      paddingY: '{spacing.xs}',
    },
    datepicker: {
      colorScheme: {
        light: {
          dropdown: {
            color: '{formField.iconColor}',
            hoverColor: '{formField.iconColor}',
            hoverBackground: '{formField.background}',
            activeBackground: '{formField.background}',
            background: '{formField.background}',
            width: '2.5rem',
          },
          header: {
            borderColor: 'transparent',
            padding: '0.5rem',
          },
          dateSelected: {
            color: '{primary.color}',
            background: '{primary.100}',
          },
          weekDay: {
            color: '{surface.300}',
            fontWeight: '400',
            fontSize: '0.875rem',
          },
          today: {
            color: '{primary.color}',
            background: '{primary.100}',
          },
        },
        dark: {
          dropdown: {
            color: '{formField.iconColor}',
            hoverColor: '{formField.iconColor}',
            hoverBackground: '{formField.background}',
            activeBackground: '{formField.background}',
            background: '{formField.background}',
            width: '2.5rem',
          },
        },
        header: {
          borderColor: 'transparent',
          padding: '0.5rem',
        },
        dateSelected: {
          color: '{primary.color}',
          background: '{primary.100}',
        },
        weekDay: {
          color: '{surface.300}',
          fontWeight: '400',
          fontSize: '0.875rem',
        },
        today: {
          color: '{primary.color}',
          background: '{primary.100}',
        },
      },
    },
    treetable: {
      column: {
        title: {
          fontWeight: '500',
        },
      },
      body: {
        cell: {
          padding: '{spacing.xxs} {spacing.sm}',
        },
      },
      colorScheme: {
        light: {
          borderColor: '{surface.200}',
        },
        dark: {
          borderColor: '{surface.200}',
        },
      },
    },
    datatable: {
      column: {
        title: {
          fontWeight: '500',
        },
      },
      body: {
        cell: {
          padding: '0px {spacing.sm}',
        },
      },
      row: {
        focusRing: {
          shadow: 'none',
          width: 0,
          offset: 0,
        },
      },
      colorScheme: {
        light: {
          border: {
            color: '{surface.200}',
          },
          row: {
            selected: {
              background: '{surface.0}',
              color: '{text.color}',
            },
          },
          body: {
            cellSelectedBorderColor: '{datatable.body.cell.border.color}',
          },
        },
        dark: {
          border: {
            color: '{surface.200}',
          },
          row: {
            selected: {
              background: '{surface.0}',
              color: '{text.color}',
            },
          },
          body: {
            cellSelectedBorderColor: '{datatable.body.cell.border.color}',
          },
        },
      },
    },
    dialog: {
      header: {
        padding: '{spacing.lg} {spacing.lg} 0 !important',
      },
      content: {
        padding: '0',
      },
      title: {
        fontWeight: '500',
      },
    },
    drawer: {
      content: {
        padding: '0',
      },
    },
    menubar: {
      gap: '0',
      border: {
        color: 'transparent',
        radius: '{border.radius.none}',
      },
    },
    panelmenu: {
      panel: {
        padding: '1.5rem',
      },
    },
    progressbar: {
      borderRadius: '1rem',
      colorScheme: {
        light: {
          background: '{primary.200}',
        },
        dark: {
          background: '{primary.200}',
        },
      },
      label: {
        font: {
          size: '1rem',
        },
      },
    },
    splitter: {
      border: {
        color: 'transparent',
        radius: '{border.radius.none}',
      },
    },
    tabs: {
      tablist: {
        background: 'none',
      },
      tab: {
        padding: '0 0 0.2rem 0',
        margin: '0 {spacing.lg} 0 0',
        border: {
          width: '0',
        },
        colorScheme: {
          light: {
            active: {
              color: '{surface.900}',
            },
          },
          dark: {
            active: {
              color: '{surface.900}',
            },
          },
          hover: {
            color: '{primary.color}',
            background: 'transparent',
          },
        },
      },
    },
    toast: {
      summary: {
        fontWeight: 700,
      },
      detail: {
        fontWeight: 400,
        fontSize: '1rem',
      },
      iconSize: '1.5rem',
      content: {
        gap: '{spacing.sm}',
      },
      colorScheme: {
        light: {
          info: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.info}',
          },
          success: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.success}',
          },
          warn: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.warn}',
          },
          error: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.error}',
          },
        },
        dark: {
          info: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.info}',
          },
          success: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.success}',
          },
          warn: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.warn}',
          },
          error: {
            background: '{content.background}',
            color: '{content.color}',
            detailColor: '{content.color}',
            borderColor: '{status.color.error}',
          },
        },
      },
    },
    togglebutton: {
      padding: '{spacing.xs}',
      colorScheme: {
        light: {
          hoverBackground: '{formField.background}',
          hoverColor: '{primary.color}',
          checked: {
            background: '{primary.color}',
            color: '{primary.contrastColor}',
            borderColor: '{surface.200}',
          },
        },
        dark: {
          hoverBackground: '{formField.background}',
          hoverColor: '{primary.color}',
          checked: {
            background: '{primary.color}',
            color: '{primary.contrastColor}',
            borderColor: '{surface.200}',
          },
        },
      },
    },
  },
};

export default wxpvConfig;
